import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Loader from "react-spinner-loader";
import { useAsyncDebounce } from "react-table";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { decryptedValue, isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { addInsuranceDetails, deleteInsuranceDetails, editInsuranceDetails, getInsuranceDetails } from "http/fundLync/insuranceDetails.helper";
import CommonDialog from "components/Common/CommonDialog";

const InsuranceDetails = ({isOpen,onAccordionToggle }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isAddPOCOpen, setAddPOCOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [insuranceDetailsList, setInsuranceDetailsList] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [insuranceData, setInsuranceDetails] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNewDataPermission, setNewDataPermission] = useState(false);
  const [isEditPocPermission, setEditPocPermission] = useState(false);
  const [pocSelectedGroup, setPocSelectedGroup] = useState(null);
  const [selectedViewInsurance, setSelectedViewInsurance] = useState(null);
  const [isViewOpen, setViewOpen] = useState(false);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [companies, setCompanies] = useState([]);
  const [typeOfInsurance, setTypeOfInsurance] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [inputValueType, setInputValueType] = useState('');
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });

  const currentDate = new Date().toISOString().split("T")[0];

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])


  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: (insuranceData && insuranceData[0].id) || "",
      insuranceCompany: (insuranceData && insuranceData[0]?.insuranceCompany) 
        ? { value: insuranceData[0].insuranceCompany, label: insuranceData[0].insuranceCompany } 
        : null,
      type: (insuranceData && insuranceData[0]?.type) 
        ? { value: insuranceData[0].type, label: insuranceData[0].type }
        : null,
      premium: (insuranceData && insuranceData[0].premium) || "",
      issuanceDate: (insuranceData && insuranceData[0].issuanceDate) || "",
      renewalDate : (insuranceData && insuranceData[0].renewalDate) || "",
      tenure: (insuranceData && insuranceData[0].tenure) || "",
    },
    validationSchema: Yup.object({
      insuranceCompany: Yup.object()
        .nullable()
        .required("Insurance Company name is Required"),
      type: Yup.object()
        .nullable()
        .required("Type of Insurance Policy is Required"),
      premium: Yup.string().required("Premium is Required"),
      issuanceDate: Yup.string().required("Issuance Date is Required"),
      renewalDate: Yup.string().required("renewal Date is Required"),
      tenure: Yup.string().required("Tenure is Required"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const data = {
          id: values.id,
          entityId: insuranceDetailsList[0]?.entityId,
          insuranceCompany: values.insuranceCompany.value,
          type: values.type.value,
          renewalDate: values.renewalDate,
          tenure: values.tenure,
          premium: values.premium,
          issuanceDate: values.issuanceDate

        }; 

        editInsuranceDetails(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Insurance Detail updated",
                showToast: true,
                role: "success",
              })
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        const data = {
            entityId:entityId,
            insuranceCompany: values.insuranceCompany.value,
            type: values.type.value,
            renewalDate: values.renewalDate,
            tenure: values.tenure,
            premium: values.premium,
            issuanceDate: values.issuanceDate
        };
        addInsuranceDetails(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Insurance Detail Saved",
                showToast: true,
                role: "success",
              });
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      validation.resetForm();
    },
  });

  useEffect(() => {
    getDropDownList({ dropdownName: "insurance_company" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "insurance_company")
            ?.dropdownValues || [];
            const transformedValues = dropdownValues.map((item) => ({
                value: item.dropdownValue,
                label: item.displayName
              }));
              setCompanies(transformedValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "type_of_insurance_policy" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "type_of_insurance_policy")
            ?.dropdownValues || [];
            const transformedValues = dropdownValues.map((item) => ({
              value: item.dropdownValue,
              label: item.displayName
            }));
            setTypeOfInsurance(transformedValues)
      })
     
      .catch((error) => {
        console.error(error);
      });
      
    checkPermissions();
  }, []);

  useEffect(() => {
    if (isOpen) { 
      getInsuranceDetails({ entityId })
        .then((response) => {
          if (response.status) {
            setInsuranceDetailsList(response?.data?.data);
          } else {
            setInsuranceDetailsList([]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } checkPermissions();
  }, [isOpen, entityId]);
  
  const checkPermissions = async () => {
    const isAddpermission = await isPermission("address", "create_permission");
    const editAddressPermission = await isPermission("address", "edit_permission");
    setNewDataPermission(isAddpermission);
    setEditPocPermission(editAddressPermission);
  };

  const handleCustomerClicks = () => {
    setAddPOCOpen(true);
    setIsEdit(false);
    setInsuranceDetails(null);
  };

  const handleCancelrClicks = () => {
    validation.resetForm();
    setAddPOCOpen(false);
    setInsuranceDetails(null);
  };

  const EditInsuranceDetails = (id) => {
    setIsEdit(true);
    const filteredData = insuranceDetailsList.filter((elem) => {
      return elem.id == id;
    });

    setInsuranceDetails(filteredData);
    let val = {label: filteredData[0]?.bankName, value: filteredData[0]?.bankName}
    setPocSelectedGroup(val);
    setAddPOCOpen(true);
  };
  

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
    setAddPOCOpen(false);
    setIsEdit(false);
    if (onAccordionToggle) {
      onAccordionToggle(!isDropdownOpen);
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, 
    })
  };
  const callPocAfterSave = () => {
    getInsuranceDetails({ entityId })
      .then((response) => {
        if (response.status) {
          setInsuranceDetailsList(response?.data?.data);
        }
        else{
            setInsuranceDetailsList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const viewInsuranceDetails = (id) => {
    const selectedData = insuranceDetailsList.find((elem) => elem.id == id);
    setSelectedViewInsurance(selectedData);
    setViewOpen(true);
  };

  const handleOptionChange = (value) => {
    setInputValue(value);
  };

  const handleOptionChangeType = (value) => {
    setInputValueType(value);
  };

  const handleCreateCompany = () => {
    const newCompany = {
      value: inputValue.toLowerCase().replace(/\s+/g, ''),
      label: inputValue,
    };
    setCompanies([...companies, newCompany]);
  };
  const handleCreateType = () => {
    const newType = {
      value: inputValueType.toLowerCase().replace(/\s+/g, ''),
      label: inputValueType,
    };
    setTypeOfInsurance([...typeOfInsurance, newType]);
  };

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteInsuranceDetails({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Insurance Detail Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callPocAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <Row lg="12">
        <div>
          <Card style={{ padding: "10px" }}>
            <div
              className="d-flex justify-content-between mt-1"
              style={{ cursor: "pointer" }}
              onClick={toggleDropdown}
            >
              <div>
                <h5>Insurance Details</h5>
              </div>
              <div className="me-2">
                <i
                  className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {isViewOpen && selectedViewInsurance && (
              <div>
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => setViewOpen(false)}
                    >
                      close
                    </Button>
                </div>
              <Row className="mb-3">
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Insurance Company</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewInsurance.insuranceCompany}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Type of Insurance Policy</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewInsurance.type}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Premium </Label>
                  <span className="mb-0 entityDetailsValue">₹ {selectedViewInsurance.premium}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Issuance Date</Label>
                  <span className="mb-0 entityDetailsValue">{formatDateString(selectedViewInsurance.issuanceDate)}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Renewal Date </Label>
                  <span className="mb-0 entityDetailsValue">{formatDateString(selectedViewInsurance.renewalDate)}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Tenure</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewInsurance.tenure}</span>
                </Col>
              </Row>
              </div>
            )}
            {isAddPOCOpen && (
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      handleSubmit(e)
                      return false;
                    }}
                  >
                    <Row className="mb-3">
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">Insurance Company <i className="mdi mdi-asterisk"></i></Label>
                        <Select
                          name="insuranceCompany"
                          options={companies}
                          onChange={(selectedOption) => {
                            validation.setFieldValue("insuranceCompany", selectedOption);
                          }}
                          onInputChange={handleOptionChange}
                          inputValue={inputValue}
                          isSearchable
                          isClearable
                          noOptionsMessage={() => (
                            <div>
                              No options found.
                              <a href="#" onClick={(e) => {
                                e.preventDefault();
                                handleCreateCompany();
                              }}>Add "{inputValue}"</a>
                            </div>
                          )}
                          value={validation.values.insuranceCompany}
                          styles={customStyles}
                          className={validation.touched.insuranceCompany && validation.errors.insuranceCompany ? 'is-invalid' : ''}
                        />
                        {validation.touched.insuranceCompany && validation.errors.insuranceCompany && (
                          <FormFeedback>{validation.errors.insuranceCompany}</FormFeedback>
                        )}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">Type of Insurance Policy <i className="mdi mdi-asterisk"></i></Label>
                        <Select
                          name="type"
                          options={typeOfInsurance}
                          onChange={(selectedOption) => {
                            validation.setFieldValue("type", selectedOption);
                          }}
                          onInputChange={handleOptionChangeType}
                          inputValue={inputValueType}
                          isSearchable
                          isClearable
                          noOptionsMessage={() => (
                            <div>
                              No options found.
                              <a href="#" onClick={(e) => {
                                e.preventDefault();
                                handleCreateType();
                              }}>Add "{inputValueType}"</a>
                            </div>
                          )}
                          value={validation.values.type}
                          styles={customStyles}
                          className={validation.touched.type && validation.errors.type ? 'is-invalid' : ''}
                        />
                        {validation.touched.type && validation.errors.type && (
                          <FormFeedback>{validation.errors.type}</FormFeedback>
                        )}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4" >Premium <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="premium"
                          type="text"
                          placeholder="Enter amount"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.premium || ""}
                          invalid={
                            validation.touched.premium &&
                              validation.errors.premium
                              ? true
                              : false
                          }
                        />
                        {validation.touched.premium &&
                          validation.errors.premium ? (
                          <FormFeedback type="invalid">
                            {validation.errors.premium}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Issuance Date <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="issuanceDate"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={formatDateString1(validation.values.issuanceDate) || ""}
                          invalid={
                            validation.touched.issuanceDate &&
                            validation.errors.issuanceDate
                          }
                          // max={currentDate}
                        />
                        {validation.touched.issuanceDate &&
                          validation.errors.issuanceDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.issuanceDate}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Renewal Date 
                        </Label>
                        <Input
                          name="renewalDate"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={formatDateString1(validation.values.renewalDate) || ""}
                          invalid={
                            validation.touched.renewalDate &&
                            validation.errors.renewalDate
                          }
                          // max={currentDate}
                        />
                        {validation.touched.renewalDate &&
                          validation.errors.renewalDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.renewalDate}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">Tenure <i className="mdi mdi-asterisk"></i> </Label>
                        <Input
                          name="tenure"
                          type="text"
                          placeholder="Enter tenure"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.tenure || ""}
                          invalid={
                            validation.touched.tenure &&
                              validation.errors.tenure
                              ? true
                              : false
                          }
                        />
                        {validation.touched.tenure &&
                          validation.errors.tenure ? (
                          <FormFeedback type="invalid">
                            {validation.errors.tenure}
                          </FormFeedback>
                        ) : null}
                      </Col>

                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <div className="text-end">
                          <button
                            type="button"
                            className="btn btn-outline-secondary save-customer me-2"
                            onClick={handleCancelrClicks}
                          >
                            Cancel
                          </button>
                          {isEdit ? (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Update
                          </button>
                          ): (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          )}
                          
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            )}
            {isDropdownOpen && (
              <Row>
                <div className="text-sm-end">
                  {isNewDataPermission && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={handleCustomerClicks}
                    >
                      <i className="mdi mdi-plus me-1" />
                      New Insurance Detail
                    </Button>
                  )}
                </div>
                <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Insurance Company</th>
                          <th>Type</th>
                          <th>Premium</th>
                          <th>Issuance Date</th>
                          <th>Renewal Date</th>
                          <th>Tenure</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {insuranceDetailsList?.length == 0 ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                            insuranceDetailsList?.map((elem, index) => (
                                
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                              <td>{elem.insuranceCompany}</td>
                              <td>{elem.type}</td>
                              <td>₹ {elem.premium}</td>
                              <td>{formatDateString(elem.issuanceDate)}</td>
                              <td>{formatDateString(elem.renewalDate)}</td>
                              <td>{elem.tenure}</td>
                              <td>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="card-drop"
                                  >
                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                  </DropdownToggle>

                                  {isEditPocPermission && 
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        EditInsuranceDetails(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-success me-1"
                                        id="edittooltip"
                                      ></i>
                                      Edit
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            viewInsuranceDetails(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-eye font-size-16 text-success me-1"
                                        id="viewtooltip"
                                        ></i>
                                        View
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="viewtooltip"
                                        >
                                        View
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            deleteDetail(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-delete font-size-16 text-success me-1"
                                        id="deletetooltip"
                                        ></i>
                                        Delete
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="deletetooltip"
                                        >
                                        Delete
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                  </DropdownMenu>
                                  }
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}
          </Card>
        </div>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};

export default InsuranceDetails;
